import React, { useEffect } from 'react';
import GameSettings from './GameSettings';

const StartScreen = ({ 
  selectedCategory, 
  setSelectedCategory, 
  selectedDifficulty, 
  setSelectedDifficulty, 
  questionCount, 
  setQuestionCount, 
  muted, 
  setMuted, 
  startGame, 
  loading, 
  error,
  onBack 
}) => {
  // Log component lifecycle
  useEffect(() => {
    console.log('[StartScreen] Component mounted/updated', {
      selectedCategory,
      selectedDifficulty,
      questionCount,
      muted,
      loading,
      hasError: !!error
    });
  }, [selectedCategory, selectedDifficulty, questionCount, muted, loading, error]);

  const handleStartGame = () => {
    console.log('[StartScreen] Start game button clicked', {
      selectedCategory,
      selectedDifficulty,
      questionCount,
      muted
    });
    startGame();
  };
  return (
    <div className="game-card">
      <h1><span role="img" aria-label="target">🎯</span> DunnoHack 2</h1>
      <p>Test your knowledge with our online trivia game!</p>
      
      <GameSettings
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedDifficulty={selectedDifficulty}
        setSelectedDifficulty={setSelectedDifficulty}
        questionCount={questionCount}
        setQuestionCount={setQuestionCount}
        muted={muted}
        setMuted={setMuted}
      />
      
      <div className="button-group">
        {onBack && (
          <button 
            className="back-button" 
            onClick={onBack}
          >
            ← Back
          </button>
        )}
        
        <button 
          className="start-button" 
          onClick={handleStartGame}
          disabled={loading}
        >
          {loading ? 'Starting Game...' : 'Start Game'}
        </button>
      </div>
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default StartScreen;
